// src/lib/api.js
// Centralized API helper: attaches JWT token, base URL, JSON handling.

function detectBase() {
  // 1) runtime injected (se voc� usar depois)
  if (typeof window !== "undefined" && window.__API_URL__) {
    return String(window.__API_URL__).replace(/\/+$/, "");
  }

  // 2) CRA build-time env (quando funciona)
  if (
    typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_API_URL
  ) {
    return String(process.env.REACT_APP_API_URL).replace(/\/+$/, "");
  }

  // 3) fallback inteligente pro seu cen�rio atual:
  // se o site est� em :3001, API est� em :3000
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    const o = window.location.origin;
    if (/:3001$/.test(o)) return o.replace(/:3001$/, ":3000");
    return o;
  }

  return "";
}

const BASE = detectBase();

function buildUrl(path) {
  if (!path.startsWith("/")) path = `/${path}`;
  return `${BASE}${path}`;
}

function getAuthHeaders(extra = {}) {
  const token = localStorage.getItem("token");
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    ...extra,
  };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

async function handleResponse(res) {
  const contentType = res.headers.get("content-type") || "";
  let data = null;

  if (contentType.includes("application/json")) {
    data = await res.json().catch(() => null);
  } else {
    data = await res.text().catch(() => null);
  }

  if (!res.ok) {
    const message =
      (data && (data.error || data.message)) ||
      `Request failed with status ${res.status}`;
    const error = new Error(message);
    error.status = res.status;
    error.data = data;
    throw error;
  }

  return data;
}

export async function apiGet(path, { headers = {} } = {}) {
  const res = await fetch(buildUrl(path), {
    method: "GET",
    headers: getAuthHeaders(headers),
    credentials: "include",
  });
  return handleResponse(res);
}

export async function apiPost(path, body = {}, { headers = {} } = {}) {
  const res = await fetch(buildUrl(path), {
    method: "POST",
    headers: getAuthHeaders(headers),
    body: JSON.stringify(body),
    credentials: "include",
  });
  return handleResponse(res);
}

export async function apiPut(path, body = {}, { headers = {} } = {}) {
  const res = await fetch(buildUrl(path), {
    method: "PUT",
    headers: getAuthHeaders(headers),
    body: JSON.stringify(body),
    credentials: "include",
  });
  return handleResponse(res);
}

export async function apiDelete(path, { headers = {} } = {}) {
  const res = await fetch(buildUrl(path), {
    method: "DELETE",
    headers: getAuthHeaders(headers),
    credentials: "include",
  });
  return handleResponse(res);
}

export async function apiUpload(path, formData, { headers = {} } = {}) {
  const token = localStorage.getItem("token");
  const res = await fetch(buildUrl(path), {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}`, ...headers } : headers,
    body: formData,
    credentials: "include",
  });
  return handleResponse(res);
}

export function setToken(token) {
  if (token) localStorage.setItem("token", token);
}

export function clearToken() {
  localStorage.removeItem("token");
}

export function getBaseUrl() {
  return BASE || (typeof window !== "undefined" ? window.location.origin : "");
}
